import { ws_domain } from "../Links/Links";

export function currentUserWebSocket(currentUserUsername, setRecentSearchData) {
  const socket = new WebSocket(ws_domain + "/ws/" + currentUserUsername + "/");

  socket.onopen = () => {

  };

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);

    console.log(data);
    setRecentSearchData((currentData) => [data, ...currentData.filter((item) => item.username !== data.username)])
    
  };

  socket.onclose = (event) => {
    console.log(event);
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  return socket;

}